import React, { Component } from "react";
import TermsView from "../views/TermsView";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../state/actions/actions";
import { withRouter } from "react-router-dom";

const mapStateToProps = state => {
  return {
    data: state.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      actions,
      dispatch
    )
  };
};

class TermsContainer extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <TermsView {...this.props} />
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsContainer)
